module.exports = __webpack_public_path__ + "img/image.723ae43c.png";